import { CONTROLLER_CATALOG_ITEM_TYPES } from "../../../enums/controllerCatalogItemTypes";
import { transformManufacturerName } from "../../../shared/utils/utils";
import { Reference } from "../../shared/refs";

export type ControllerManufacturerRef = Reference;

export interface ControllerModelRef {
  faultListId: string;
  faultListLabel: string;
  modelId: string;
  modelLabel: string;
}

export interface ControllerManufacturerObject {
  id?: string;
  label: string;
  notes?: string | null;
  models?: ControllerModelRef[];
}

export class ControllerManufacturer {
  public id?: string;
  label: string;
  public notes?: string | null;
  public selected = false;
  public controllerCatalogItemType: string = CONTROLLER_CATALOG_ITEM_TYPES.MANUFACTURER;
  public models?: ControllerModelRef[];
  constructor(manufacturer: ControllerManufacturerObject) {
    this.id = manufacturer.id;
    this.label = transformManufacturerName(manufacturer.label);
    this.models = manufacturer.models;
    this.notes = manufacturer.notes;
  }

  public set properties(manufacturer: ControllerManufacturerObject) {
    this.label = transformManufacturerName(manufacturer.label);

    this.notes = manufacturer.notes;
  }

  public get values() {
    const manufacturer: ControllerManufacturerObject = {
      label: this.label,
      id: this.id,
      notes: this.notes,
    };
    return manufacturer;
  }
}
